import { render, staticRenderFns } from "./DeclineArtworkApprovalRequest.vue?vue&type=template&id=8c420c60&scoped=true"
import script from "./DeclineArtworkApprovalRequest.vue?vue&type=script&lang=js"
export * from "./DeclineArtworkApprovalRequest.vue?vue&type=script&lang=js"
import style0 from "./DeclineArtworkApprovalRequest.vue?vue&type=style&index=0&id=8c420c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c420c60",
  null
  
)

export default component.exports